<template>
  <Modal
    v-model="_value"
    width="800"
    title="配置定位设备"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <div style="position:relative;">
      <Table border highlight-row size="small" height="200" :columns="columns" :stripe="true" :data="content"
             ref="table"
             @on-sort-change="sortChange"></Table>
      <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
        <Spin size="large"></Spin>
        <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
      </div>
    </div>
    <Form autoComplete="on" class="card-box login-form">
      <Form-item label="设备主机号">
        <Select
          v-model="selectPositioningDeviceInfos"
          multiple
          filterable
          remote
          :remote-method="searchPositioningDeviceInfo"
          :loading="searchPositioningDeviceInfoLoading">
          <Option v-for="(option, index) in searchPositioningDeviceInfoList" :value="option.id" :key="option.id">
            {{option.terminalNum}}
          </Option>
        </Select>
      </Form-item>
    </Form>
    <Row type="flex" justify="end">
      <Button type="primary" @click="onBindPositioningDeviceInfos">绑定</Button>
    </Row>

    <positioning-device-info-detail-modal v-model="positioningDeviceInfoDetailModal"
                                          :initValue="positioningDeviceInfoDetailId"></positioning-device-info-detail-modal>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import PositioningDeviceInfoDetailModal from '@/view/im/components/positioning-device-info-detail-modal'

export default {
  name: 'assemblepositioningdeviceinfomodal',
  components: {
    PositioningDeviceInfoDetailModal
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      modify: false,
      positioningDeviceInfoDetailModal: false,
      positioningDeviceInfoDetailId: null,
      searchPositioningDeviceInfoList: [],
      searchPositioningDeviceInfoLoading: false,
      selectPositioningDeviceInfos: [],
      positioningDeviceInfoStateOptions: [
        { label: '未安装', value: 1 },
        { label: '已安装', value: 2 },
        { label: '损坏', value: 3 }
      ],
      // positioningDeviceModelOptions: [
      //   { label: 'BSJ-A6-BD', value: 1 },
      //   { label: 'BSJ-GF03', value: 2 },
      //   { label: 'BSJ-M11', value: 3 },
      //   { label: 'BSJ-A6L', value: 13 },
      //   { label: 'BSJ-A7', value: 14 },
      //   { label: 'K5', value: 4 },
      //   { label: 'D5X', value: 5 },
      //   { label: 'G-3G', value: 6 },
      //   { label: 'D5X-HDD', value: 7 },
      //   { label: 'D5X-XR', value: 8 },
      //   { label: 'BSJ-GF06', value: 9 },
      //   { label: 'BSJ-RM01', value: 10 },
      //   { label: 'HIK-A3', value: 11 },
      //   { label: 'HIK-A3L', value: 12 }
      // ],
      positioningDeviceSourceTypeOptions: [
        { label: '新装', value: 1 },
        { label: '接入', value: 2 }
      ],
      positioningDeviceInfo: {
        id: null,
        terminalNum: null,
        factoryTerminalNum: null,
        positioningDeviceModel: null,
        positioningDeviceModelId: null,
        sourceType: null,
        remark: null,
        setupDatetime: null,
        serviceDatetime: null
      },
      listLoadding: false,
      columns: [
        {
          title: 'ID',
          resizable: true,
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          minWidth: 70
        },
        {
          title: '主机号',
          resizable: true,
          key: 'terminalNum',
          ellipsis: 'true',
          minWidth: 160
        },
        {
          title: '状态',
          resizable: true,
          key: 'terminalNum',
          ellipsis: 'true',
          minWidth: 80,
          render: function (h, params) {
            if (params.row.serviceState == 0) {
              return h('div', '停止服务')
            } else if (params.row.serviceState == 1) {
              return h('div', '正常')
            }
          }
        },
        {
          title: '设备型号',
          resizable: true,
          key: 'positioningDeviceModelId',
          ellipsis: 'true',
          minWidth: 100,
          render: function (h, params) {
            if (params.row.positioningDeviceModel) {
              let positioningDeviceModel = params.row.positioningDeviceModel
              return h('div', positioningDeviceModel.name)
            } else {
              return h('div', '未知')
            }
          }
        },
        {
          title: '备注',
          resizable: true,
          key: 'remark',
          ellipsis: 'true',
          tooltip: 'true',
          minWidth: 100
        },
        {
          title: '设备来源',
          resizable: true,
          key: 'sourceType',
          ellipsis: 'true',
          minWidth: 100,
          render: function (h, params) {
            let sourceType = params.row.sourceType
            if (sourceType === 1) {
              return h('div', '新装')
            } else if (sourceType === 2) {
              return h('div', '接入')
            }
          }
        },
        {
          title: '操作',
          resizable: true,
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          minWidth: 120,
          render: (h, params) => {
            let display = []

            // return h('div', [
            display.push(
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.positioningDeviceInfoDetailId = params.row.id
                    this.positioningDeviceInfoDetailModal = true
                  }
                }
              }, '详细信息')
            )
            display.push(
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '确认解绑设备',
                      content: '<p>确认解绑设备</p>',
                      onOk: () => {
                        store.dispatch('PositioningDeviceFittingServ_UnBindPositioningdeviceInfo', {
                          params: { id: this._initValue }
                        }).then(() => {
                          this.$Message.success('修改成功')
                          this.updateTable()
                          this.$emit('on-success')
                        }).catch(err => {
                          this.$Message.error(err)
                          this.$emit('on-fail')
                        })
                      },
                      onCancel: () => {

                      }
                    })
                  }
                }
              }, '解绑')
            )
            // ])

            return h('div', display)
          }
        }
      ]
    }
  },
  methods: {
    ...mapActions([
      'PositioningDeviceInfoServ_GetDetail',
      'PositioningDeviceInfoServ_ModifyObj',
      'VehicleInfoServ_BindPositioningDeviceInfos',
      'VehicleInfoServ_UnBindPositioningDeviceInfos',
      'PositioningDeviceInfoServ_GetAll'
    ]),
    onBindPositioningDeviceInfos () {
      console.log(this.selectPositioningDeviceInfos)
      this.$Modal.confirm({
        title: '确认绑定设备',
        content: '<p>确认绑定设备</p>',
        onOk: () => {
          store.dispatch('PositioningDeviceFittingServ_BindPositioningdeviceInfo', {
            params: { id: this._initValue, positioningdeviceinfoid: this.selectPositioningDeviceInfos[0] }
          }).then(() => {
            this.$Message.success('修改成功')
            this.updateTable()
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {

        }
      })
    },
    searchPositioningDeviceInfo (input) {
      this.searchPositioningDeviceInfoLoading = true
      if (!input || input.length <= 0) {
        this.searchPositioningDeviceInfoList = []
        this.searchPositioningDeviceInfoLoading = false
      } else {
        store.dispatch('PositioningDeviceInfoServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchPositioningDeviceInfoList = store.getters.get_PositioningDeviceInfo_SearchByNameResult ? store.getters.get_PositioningDeviceInfo_SearchByNameResult : []
          this.searchPositioningDeviceInfoLoading = false
        }).catch(err => {
          this.searchPositioningDeviceInfoLoading = false
        })
      }
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage()
    },
    updateTable () {
      this.listLoadding = true

      store.dispatch('PositioningDeviceFittingServ_GetDetail', {
        params: {
          id: this._initValue
        },
        urlparams: null
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    visibleChange (val) {
      if (val) {
        this.searchPositioningDeviceInfoList = []
        this.selectPositioningDeviceInfos = []
        this.listLoadding = true
        store.dispatch('PositioningDeviceFittingServ_GetDetail', {
          params: {
            id: this._initValue
          },
          urlparams: null
        }).then(() => {
          this.listLoadding = false
        }).catch(err => {
          this.listLoadding = false
          this.$Message.error(err)
        })
      }
    }
  },
  computed: {
    content () {
      if (store.getters.get_PositioningDeviceFitting_GetDetailResult) {
        if (store.getters.get_PositioningDeviceFitting_GetDetailResult.positioningDeviceInfoId != null) {
          return [store.getters.get_PositioningDeviceFitting_GetDetailResult.positioningDeviceInfo]
        } else {
          return []
        }
      } else {
        return []
      }
    },
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
